export default encodedStr =>
  encodedStr
    .replace(
      /[\u00A0-\u9999<>&]/gim,
      (i) => '&#' + i.charCodeAt(0) + ';');